<template>
  <td>
    <div ref="dropdown" class="dropdown dropleft" :class="{ show: show }">
      <button
        @click="show = !show"
        :disabled="deleted"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <router-link :to="`/systemuser/${content}`" class="dropdown-item"
          >Bearbeiten</router-link
        >
        <div @click="toggleUserDisabled()" class="dropdown-item">
          {{ userDisabledText }}
        </div>
        <div class="dropdown-item" @click="remove" :disabled="deleting">
          Löschen
        </div>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  props: ["content", "model", "tableId"],
  data() {
    return {
      show: false,
      deleting: false
    };
  },
  computed: {
    deleted() {
      return Boolean(this.model.deleted_at);
    },
    isDisabled() {
      return Boolean(this.model.disabled_at);
    },
    userDisabledText() {
      return this.isDisabled ? "User entsperren" : "User sperren";
    }
  },
  methods: {
    remove() {
      this.show = false;
      if (this.deleting) {
        return;
      }

      if (!confirm("Sicher?")) {
        return;
      }

      this.deleting = true;

      this.$store
        .dispatch("user/delete", { url: this.model.delete_url })
        .then(() => this.$emit("table-update", { count: true }))
        .finally(() => (this.deleting = false));
    },
    toggleUserDisabled() {
      this.show = false;

      if (this.isDisabled) {
        this.enableUser();
      } else {
        this.disableUser();
      }
    },
    disableUser() {
      if (this.isDisabled) {
        return;
      }
      this.$http
        .post("/api/v1/userDisabled", {
          user_id: this.model.id,
          message: null
        })
        .then(({ data }) => {
          this.$store.commit("table/updateModel", {
            tableId: this.tableId,
            modelId: this.model.id,
            attributePath: "disabled_at",
            data: data
          });

          this.$notify({
            title: `${this.model.name} wurde gesperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.show = false;
          this.$emit("table-update");
        });
    },
    enableUser() {
      if (!this.isDisabled) {
        return;
      }
      this.$http
        .delete(`/api/v1/userDisabled/${this.model.id}`)
        .then(() => {
          this.$store.commit("table/updateModel", {
            tableId: this.tableId,
            modelId: this.model.id,
            attributePath: "disabled_at",
            data: undefined
          });
          this.$notify({
            title: `${this.model.name} wurde entsperrt`,
            type: "success"
          });
        })
        .finally(() => {
          this.show = false;
          this.$emit("table-update");
        });
    }
  }
};
</script>

<style></style>
